import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { COLORS } from "styled/colors";

const Typography = ({
  children,
  variant = "p",
  textAlign = "left",
  padding = [0, 0, 0, 0],
  margin = [0, 0, 0, 0],
  className = "",
  color = COLORS.text.black,
  display = "block",
  title = "",
  lineHeight = 16,
  testId = "typography",
}) => {
  return (
    <StyledTypography
      as={variant}
      padding={padding}
      margin={margin}
      textAlign={textAlign}
      className={className}
      color={color}
      display={display}
      title={title}
      lineHeight={lineHeight}
      data-testid={testId}
    >
      {children}
    </StyledTypography>
  );
};

const StyledTypography = styled.p`
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight}px;
    `}
  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
  ${(props) =>
    props.padding &&
    css`
      padding-top: ${props.padding[0]}px;
      padding-right: ${props.padding[1]}px;
      padding-bottom: ${props.padding[2]}px;
      padding-left: ${props.padding[3]}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
    ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}
`;

Typography.propTypes = {
  padding: PropTypes.arrayOf(PropTypes.number),
  margin: PropTypes.arrayOf(PropTypes.number),
  variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p", "small"]),
  textAlign: PropTypes.oneOf(["left", "right", "center"]),
  display: PropTypes.oneOf(["block", "inline-block"]),
  lineHeight: PropTypes.number,
};

export default Typography;
